import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import PDVSComPotencial from "../PCendSKIN/components/PDVSComPotencial";
import PCandSkin from "../PCendSKIN/components/PCandSkin";
import RankingDistribuicao from "../PCendSKIN/components/RankingDistribuicao";
import RankingSegmento from "../PCendSKIN/components/RankingSegmento";
import RankingCidade from "../PCendSKIN/components/RankingCidade";
import RankingUF from "../PCendSKIN/components/RankingUF";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function BodyHandFacialPotinhosDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);

  const getNameUser = useCallback(async () => {}, []);

  useEffect(() => {
    if (app) {
      getNameUser();
    }
  }, [app, getNameUser, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container flexDirection="column" justifyContent="flex-start" rowGap={2}>
            {isLoading ? (
              <Grid container spacing={2}>
                <Grid item xs={12} md={7}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={5}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={7} className="container-tables-tops">
                    <PDVSComPotencial app={app} objectId="20d78b17-5e99-46e8-bdcf-5422b17a1fca" />
                  </Grid>
                  <Grid item xs={12} md={5} className="container-tables-tops">
                    <PCandSkin app={app} title="(BodyHand) + (F P)" objectId="a80a0ec6-2096-477a-9e09-a39561c3f8eb" />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item spacing={2} xs={12} md={6} xl={3} className="container-tables-tops">
                    <RankingDistribuicao app={app} objectId="2c510c52-d1c1-498d-b2cd-66198d780924" />
                  </Grid>
                  <Grid item spacing={2} xs={12} md={6} xl={3} className="container-tables-tops">
                    <RankingSegmento app={app} objectId="d563fc1c-82f8-4470-8292-8ccedf57c7f3" />
                  </Grid>
                  <Grid item spacing={2} xs={12} md={6} xl={3} className="container-tables-tops">
                    <RankingUF app={app} objectId="d411ae03-b558-41d8-82a2-1454851f808c" />
                  </Grid>
                  <Grid item spacing={2} xs={12} md={6} xl={3} className="container-tables-tops">
                    <RankingCidade app={app} objectId="421593c1-b744-4acf-b6c2-7b6fdd14dde1" />
                  </Grid>
                </Grid>
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

BodyHandFacialPotinhosDesktop.propTypes = {
  app: PropTypes.object,
};

export default BodyHandFacialPotinhosDesktop;
